import * as React from "react";
import { routes } from "configs";

const AssessmentPackage = React.lazy(
  () => import("./teacher/search-tool/assessment-package/AssessmentPackage"),
);
const ScopeElement = React.lazy(
  () => import("./teacher/search-tool/scope-element"),
);
const SearchToolScopes = React.lazy(
  () => import("./teacher/search-tool/scopes"),
);
const SearchToolAssessmentPackages = React.lazy(
  () => import("./teacher/search-tool/assessment-packages"),
);
const StudentAssignment = React.lazy(() => import("./student/assignment"));
const AssignmentReview = React.lazy(
  () => import("./teacher/assignment/review"),
);
const AssignmentPreview = React.lazy(
  () => import("./teacher/assignment/preview"),
);
const Scope = React.lazy(() => import("./teacher/search-tool/scope"));

export default [
  {
    path: routes.lti.canvas.searchToolScopes,
    key: routes.lti.canvas.searchToolScopes,
    component: SearchToolScopes,
    exact: true,
  },
  {
    path: routes.lti.canvas.searchToolAssessmentPackages,
    key: routes.lti.canvas.searchToolAssessmentPackages,
    component: SearchToolAssessmentPackages,
    exact: true,
  },
  {
    path: routes.lti.canvas.searchToolScope,
    key: routes.lti.canvas.searchToolScope,
    component: Scope,
    exact: true,
  },
  {
    path: routes.lti.canvas.searchToolElement,
    key: routes.lti.canvas.searchToolElement,
    component: ScopeElement,
    exact: true,
  },
  {
    path: routes.lti.canvas.searchToolAssessmentPackage,
    key: routes.lti.canvas.searchToolAssessmentPackage,
    component: AssessmentPackage,
    exact: true,
  },
  {
    path: routes.lti.canvas.studentAssignment,
    key: routes.lti.canvas.studentAssignment,
    component: StudentAssignment,
    exact: true,
  },
  {
    path: routes.lti.canvas.review,
    key: routes.lti.canvas.review,
    component: AssignmentReview,
    exact: true,
  },
  {
    path: routes.lti.canvas.preview,
    key: routes.lti.canvas.preview,
    component: AssignmentPreview,
    exact: true,
  },
];
